export const getToken = () => {
  return localStorage.getItem('token');
};

export const getRefreshToken = () => {
  return localStorage.getItem('refreshToken');
};

export const removeToken = () => {
  localStorage.removeItem('token');
};

export const removeRefreshToken = () => {
  localStorage.removeItem('refreshToken');
};

export const setToken = (val: string) => {
  localStorage.setItem('token', val);
};

export const setRefreshToken = (val: string) => {
  localStorage.setItem('refreshToken', val);
};

export const getUserData = () => {
  return localStorage.getItem('userData');
};

export const removeUserData = () => {
  localStorage.removeItem('userData');
};

export const setUserData = (val: string) => {
  localStorage.setItem('userData', val);
};
